import { call, put, select, takeLatest } from 'redux-saga/effects'
import SeedTrackerActions from 'modules/domain/seedTracker/duck'
import SeedTrackerSelectors from 'modules/domain/seedTracker/selectors'
import * as managers from 'modules/domain/seedTracker/managers'
import { SeedTracker } from 'modules/domain/seedTracker/types'
import { RequestError } from 'modules/errors'
import { updateLocationQuery } from 'modules/sagaHelpers'
import SeedTrackerRoutes from 'views/pages/SeedTracker/routes'
import { ListResponse } from 'types/api'

export const fetchList = function* () {
  try {
    let currentPage = yield select(SeedTrackerSelectors.page)
    const filter = yield select(SeedTrackerSelectors.filter)
    const sorting = yield select(SeedTrackerSelectors.sorting)
    const pageSize = yield select(SeedTrackerSelectors.pageSize)

    let response: ListResponse<SeedTracker> = yield call(
      managers.getSeedTrackersList,
      filter,
      sorting,
      currentPage,
      pageSize,
    )
    const pages = Math.ceil(response.total_count / pageSize)
    if (pages !== 0 && pages < currentPage) {
      response = yield call(managers.getSeedTrackersList, filter, sorting, pages, pageSize)
      currentPage = pages
    }

    const { data, page, total_count, meta } = response
    yield put(SeedTrackerActions.listRequestSucceed(data, total_count, page, meta))
    yield call(updateLocationQuery, SeedTrackerRoutes.List, { page: currentPage })
  } catch (err) {
    const errType = err instanceof RequestError ? err.type : 'unknown'
    yield put(SeedTrackerActions.listRequestFailed(errType))
  }
}

const SeedTrackerSaga = function* () {
  yield takeLatest(SeedTrackerActions.listRequested.type, fetchList)
  yield takeLatest(SeedTrackerActions.filterUpdated.type, fetchList)
  yield takeLatest(SeedTrackerActions.sortingUpdated.type, fetchList)
}

export default SeedTrackerSaga
